'use client';

import Container from '@/components/ui/Container';
import { easeInOut, motion } from 'framer-motion';
import Image from 'next/image';

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

const services = [
  'Tailored Engineering Solutions',
  '24/7 Technical Support',
  'Certified & Experienced Engineers',
];

const ProfessionalService = () => {
  return (
    <Container backgroundColor="2xl:h-[700px]">
      <div className="grid items-center gap-12 md:grid-cols-2">
        {/* Text Section */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h2 className="mb-4 text-4xl font-bold text-gray-800 dark:text-white">
            Professional Services That Elevate Infrastructure
          </h2>

          <p className="mb-6 text-lg text-gray-600 dark:text-white/90">
            At A1 Lifts & Engineering, we offer expert services in lift
            installations, generator systems, and substation maintenance. Our
            team ensures quality, reliability, and long-term performance with
            every project.
          </p>

          <ul className="space-y-3 text-gray-700 dark:text-white/90">
            {services.map((item, index) => (
              <li key={index} className="flex items-start gap-2">
                ✅ {item}
              </li>
            ))}
          </ul>
        </motion.div>

        {/* Floating Image */}
        <motion.div
          animate={{ y: [0, -20, 0] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: easeInOut,
          }}
          className="relative h-[350px] w-full overflow-hidden rounded-2xl shadow-2xl"
        >
          <Image
            src="/assets/images/services/power-distribution.jpg"
            alt="Floating Service"
            fill
            className="object-cover"
            priority
          />
        </motion.div>
      </div>
    </Container>
  );
};

export default ProfessionalService;
